import React from "react";

import type { AudienceSectionContent } from "../content/types";

type AudienceSectionProps = {
  content: AudienceSectionContent;
};

export function AudienceSection({ content }: AudienceSectionProps) {
  return (
    <section className="db-section section-band audience-section" id={content.id} aria-labelledby={`${content.id}-title`}>
      <div className="db-container audience-section__inner">
        <div className="section-heading audience-section__heading">
          <p className="section-eyebrow">{content.eyebrow}</p>
          <h2 id={`${content.id}-title`}>{content.title}</h2>
          <p>{content.lead}</p>
        </div>

        <div className="audience-section__groups" aria-label={content.title}>
          {content.groups.map((group, index) => {
            const groupTitleId = `${content.id}-${group.id}-title`;

            return (
              <article className="audience-section__group" aria-labelledby={groupTitleId} key={group.id}>
                <span className="audience-section__index" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="audience-section__copy">
                  <h3 id={groupTitleId}>{group.title}</h3>
                  <ul>
                    {group.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
